import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Grid, Typography } from '@mui/material';
import { getLogin, getTokenVerify } from 'redux/actions/UserLogin';
import CommonForm from 'components/commonForm/CommonForm';
import Loader from 'components/loader/Loader';
import Otp from 'pages/otp/Otp';
import loginHand from 'assets/images/login_hand.png';
import { companyDetails } from 'utils/companyDetails';

export default function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const magicToken = searchParams?.get('Token');
  const redirectUrl = searchParams?.get('redirect'); // ✅ get redirect directly from query param

  const userLogin = useSelector((state) => state);
  const isLoader = userLogin?.userLogin?.loading;
  const [onOtp, setOnOtp] = useState(false);

  // Magic token login (keeps original behavior)
  useEffect(() => {
    if (magicToken) {
      localStorage.setItem('token', magicToken);
      dispatch(getTokenVerify(magicToken));
    }
  }, [magicToken, dispatch]);

  const onOtpPage = (val) => {
    setOnOtp(val);
  };

  const loginForm = [
    {
      placeholder: ' Email ID',
      required: true,
      type: 'text',
      name: 'email',
      label: 'Email ID',
      star: '*',
      countrycode: false,
    },
  ];

  const onLogin = (data) => {
    localStorage.clear();
    const loginPayload = {
      userDetails: {
        platform: 'AdminApp',
        mobileOrEmail: data.email,
        countryCode: data?.countryCode || '+91',
      },
      actionType: 'login',
    };
    dispatch(getLogin(loginPayload, navigate, setOnOtp));
  };

  // If login request was successful → show OTP step
  useEffect(() => {
    if (userLogin?.userLogin?.userLogin?.success) {
      setOnOtp(true);
    } else {
      setOnOtp(false);
    }
  }, [isLoader, userLogin]);

  return (
    <div>
      {!onOtp && (
        <Box sm={{ flexGrow: 1 }} className="mobileRes loginMain">
          {magicToken ? (
            <Loader />
          ) : (
            <Grid container>
              {/* ---login Part--- */}
              <Grid item sm={6}>
                {/* ---login nav--- */}
                <Box
                  sx={{
                    display: { xs: 'none', sm: 'flex' },
                    alignItems: 'center',
                  }}
                  className="positionAbsolute"
                >
                  <img src={companyDetails?.companyLogo} className="logoImg" alt="otplogo" />
                </Box>
                {/* ---login input type--- */}
                <div className="loginInput mobileBg loginMain">
                  <Grid container justifyContent="center" alignItems="center" rowSpacing={6}>
                    <Grid item sm={10} className="grideItemCenter">
                      <img src={loginHand} alt="hand" />
                      <Typography className="fontBold font36 colorBlue">
                        Let's get <span className="colorYellow">started</span>
                      </Typography>
                      <Typography className="colorGrey fontInput fontNormal">
                        Enter your Login details below
                      </Typography>
                    </Grid>
                    <Grid item sm={7}>
                      <CommonForm
                        formData={loginForm}
                        button={'Login'}
                        onSubmittBtn={onLogin}
                        loading={isLoader}
                      />
                    </Grid>
                  </Grid>
                </div>
              </Grid>
              {/* ---Image Part--- */}
              <Grid item sm={6} sx={{ display: { xs: 'none', sm: 'flex' } }}>
                <div className="loginBgImg"></div>
              </Grid>
            </Grid>
          )}
        </Box>
      )}
      {onOtp && <Otp onOtpPage={onOtpPage} redirectUrl={redirectUrl} />} {/* ✅ pass redirectUrl to OTP */}
    </div>
  );
}
